import request from '@/utils/request'

// 创建公寓
export function createBuilding(data) {
  return request({
      url: '/apartment/create',
      method: 'post',
      data,
  })
}
// 修改公寓
export function updateBuilding(data) {
  return request({
      url: '/apartment/update',
      method: 'post',
      data,
  })
}
// 删除公寓
export function removeBuilding(data) {
  return request({
      url: '/apartment/remove',
      method: 'post',
      data,
  })
}
// 获取公寓
export function findBuilding(params) {
  return request({
      url: '/apartment/find',
      method: 'get',
      params,
  })
}
// 获取公寓列表
export function findBuildingList(params) {
  return request({
      url: '/apartment/findList',
      method: 'get',
      params,
  })
}
// 获取所有公寓
export function findBuildingAll(params) {
  return request({
      url: '/apartment/findAll',
      method: 'get',
      params,
  })
}

// 创建公寓房型
export function createRoom(data) {
  return request({
      url: '/apartment/createRoom',
      method: 'post',
      data,
  })
}
// 修改公寓房型
export function updateRoom(data) {
  return request({
      url: '/apartment/updateRoom',
      method: 'post',
      data,
  })
}
// 删除公寓房型
export function removeRoom(data) {
  return request({
      url: '/apartment/removeRoom',
      method: 'post',
      data,
  })
}
// 获取公寓房型
export function findRoom(params) {
  return request({
      url: '/apartment/findRoom',
      method: 'get',
      params,
  })
}
// 获取公寓房型列表
export function findRoomList(params) {
  return request({
      url: '/apartment/findRoomList',
      method: 'get',
      params,
  })
}
// 获取所有公寓房型
export function findRoomAll(params) {
  return request({
      url: '/apartment/findRoomAll',
      method: 'get',
      params,
  })
}
// 预约公寓房型
export function orderRoom(data) {
  return request({
      url: '/apartment/orderRoom',
      method: 'post',
      data,
  })
}
// 取消预约
export function removeOrderRoom(data) {
  return request({
      url: '/apartment/removeOrderRoom',
      method: 'post',
      data,
  })
}

// 创建公寓动态
export function createEssay(data) {
  return request({
      url: '/apartment/createEssay',
      method: 'post',
      data,
  })
}
// 修改公寓动态
export function updateEssay(data) {
  return request({
      url: '/apartment/updateEssay',
      method: 'post',
      data,
  })
}
// 删除公寓动态
export function removeEssay(data) {
  return request({
      url: '/apartment/removeEssay',
      method: 'post',
      data,
  })
}
// 获取公寓动态
export function findEssay(params) {
  return request({
      url: '/apartment/findEssay',
      method: 'get',
      params,
  })
}
// 获取公寓动态列表
export function findEssayList(params) {
  return request({
      url: '/apartment/findEssayList',
      method: 'get',
      params,
  })
}


// 位置相关
// 新增州 ex: title 标题, lat 纬度, lng 经度, order 顺序
export function createProvince(data) {
  return request({
      url: '/apartment/createProvince',
      method: 'post',
      data,
  })
}
// 修改州 provinceId
export function editProvince(data) {
  return request({
      url: '/apartment/updateProvince',
      method: 'post',
      data,
  })
}
// 删除州
export function delProvince(data) {
  return request({
      url: '/apartment/removeProvince',
      method: 'post',
      data,
  })
}
// 获取单个州
export function getProvince(params) {
  return request({
      url: '/apartment/findProvince',
      method: 'get',
      params,
  })
}
// 获取州列表
export function getProvinceList(params) {
  return request({
      url: '/apartment/findProvinceList',
      method: 'get',
      params,
  })
}
// 获取所有州
export function getProvinceAll(params) {
  return request({
      url: '/apartment/findProvinceAll',
      method: 'get',
      params,
  })
}
// 新增街区 ex: title 标题, provinceId 所属州, order 顺序
export function createCity(data) {
  return request({
      url: '/apartment/createCity',
      method: 'post',
      data,
  })
}
// 修改街区 provinceId
export function editCity(data) {
  return request({
      url: '/apartment/updateCity',
      method: 'post',
      data,
  })
}
// 删除街区
export function delCity(data) {
  return request({
      url: '/apartment/removeCity',
      method: 'post',
      data,
  })
}
// 获取单个街区
export function getCity(params) {
  return request({
      url: '/apartment/findCity',
      method: 'get',
      params,
  })
}
// 获取街区列表
export function getCityList(params) {
  return request({
      url: '/apartment/findCityList',
      method: 'get',
      params,
  })
}
// 获取所有街区
export function getCityAll(params) {
  return request({
      url: '/apartment/findCityAll',
      method: 'get',
      params,
  })
}
// 设置公寓配置，post apartment/setupConfig，参数：
// orderExtraInfo // [{title//标题, require//必填：1，选填：0}]
export function setupConfig(data) {
  return request({
      url: '/apartment/setupConfig',
      method: 'post',
      data,
  })
}
// 获取配置：get app/getConfig，参数：
// key // 固定APARTMENT
export function getConfig(params) {
  return request({
      url: '/app/getConfig',
      method: 'get',
      params,
  })
}